import React from 'react'

export function OpenIcon (props) {
  return (
    <svg style={props.style}>
      <g>
        <path
          className='st0'
          d='M21.4,17.1c0-0.6,0.5-1.1,1.1-1.1s1.1,0.5,1.1,1.1v6.5c0,1.8-1.5,3.2-3.2,3.2H8.4c-1.8,0-3.2-1.5-3.2-3.2V11.7
      c0-1.8,1.5-3.2,3.2-3.2h6.5c0.6,0,1.1,0.5,1.1,1.1s-0.5,1.1-1.1,1.1H8.4c-0.6,0-1.1,0.5-1.1,1.1v11.9c0,0.6,0.5,1.1,1.1,1.1h11.9
      c0.6,0,1.1-0.5,1.1-1.1V17.1z'
        />
        <path
          className='st0'
          d='M24.6,7.4h-5.4c-0.6,0-1.1-0.5-1.1-1.1s0.5-1.1,1.1-1.1h6.5c0.6,0,1.1,0.5,1.1,1.1v6.5c0,0.6-0.5,1.1-1.1,1.1
      s-1.1-0.5-1.1-1.1V7.4z'
        />
        <path
          className='st0'
          d='M14.6,18.9c-0.4,0.4-1.1,0.4-1.5,0c-0.4-0.4-0.4-1.1,0-1.5L25,5.5c0.4-0.4,1.1-0.4,1.5,0
      c0.4,0.4,0.4,1.1,0,1.5L14.6,18.9z'
        />
      </g>
    </svg>
  )
}
